import Tips from './Tips';

export { Tips };
